import React from "react";

import "./TableHeading.css";

export default function TableHeading(props){
    return (
        <th className = "admin-panel-table-head">{props.children}</th>
    );

}